/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type VehicleDrawerStatusBarVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  inService: boolean | null
  notInServiceReasons: Array<Types.NotInServiceReason> | null
  isSelfDriving: boolean
  pooling: {
    __typename?: 'Pooling'
    enabled: boolean
    enabledUpdatedAt: string | null
    reason: Types.PoolingReason | null
    connected: boolean | null
    connectedUpdatedAt: string | null
  } | null
  latestADTelemetry?: {
    __typename?: 'ADTelemetry'
    signalConnectivityState: {
      __typename?: 'ADConnectivityStateWithTimestamp'
      connectivityState: Types.AdConnectivityState
      timestamp: string
    } | null
    cabinConnectivityState: {
      __typename?: 'ADConnectivityStateWithTimestamp'
      connectivityState: Types.AdConnectivityState
      timestamp: string
    } | null
    missionConnectivityState: {
      __typename?: 'ADConnectivityStateWithTimestamp'
      connectivityState: Types.AdConnectivityState
      timestamp: string
    } | null
  } | null
}

export const VehicleDrawerStatusBarVehicleFragmentDoc = gql`
    fragment VehicleDrawerStatusBarVehicle on Vehicle {
  id
  pooling {
    enabled
    enabledUpdatedAt
    reason
    connected
    connectedUpdatedAt
  }
  inService
  notInServiceReasons
  latestADTelemetry @include(if: $withAdTelemetryData) {
    signalConnectivityState {
      connectivityState
      timestamp
    }
    cabinConnectivityState {
      connectivityState
      timestamp
    }
    missionConnectivityState {
      connectivityState
      timestamp
    }
  }
  isSelfDriving
}
    `
